import { Fragment, useState } from "react";
import ScanBarcode from "./components/ScanBarcode";
import Menu from "../../modules/public/menu/menu";
import Footer from "../../modules/public/footer/footer";
import SendBarcode from "./components/SendBarcode";
import { Button, Col } from "react-bootstrap";
import { FaCamera } from "react-icons/fa6";

export default function ScannerPage() {
  const [barcode, setBarcode] = useState("");
  const [showCamera, setShowCamera] = useState(false);

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1 rtl-all container py-5">
        <SendBarcode barcode={barcode} setBarcode={setBarcode} />

        <Col xs={12} sm={8} md={6} xl={4} className="mx-auto mb-3">
          <Button
            variant="outline-primary"
            className="d-flex align-items-center"
            onClick={() => setShowCamera(!showCamera)}
          >
            <FaCamera className="ms-2" size="18" style={{ marginTop: -3 }} />
            <span>اسکن با دوربین</span>
          </Button>
        </Col>

        {showCamera && (
          <Fragment>
            <p className="mb-0">لطفا دوربین را کامل مقابل بارکد قرار دهید</p>
            <ScanBarcode onScan={setBarcode} />
          </Fragment>
        )}
      </main>

      <Footer />
    </Fragment>
  );
}
